import { Grid, Typography } from "@mui/material";

import Select from "components/Select";
import { useFormContext } from "react-hook-form";

function DesktopDepositNetworks({ selectedCoinNetworks }) {
  const { watch, setValue } = useFormContext();
  const network = watch("network");

  const handleChange = (e) => {
    const val = e?.target?.value;

    setValue("network", val);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main" marginTop={4} fontWeight={400}>
        Network
      </Typography>

      <Select
        dir="ltr"
        items={selectedCoinNetworks}
        itemValue="networkId"
        itemText="networkName"
        value={network}
        onChange={handleChange}
        marginBottom={3}
      />
    </Grid>
  );
}

export default DesktopDepositNetworks;
